import React from 'react'
import { OBadge } from '@dnvgl-onefoundation/onedesign-react'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const BetaBadge = ({ size = 'md', className }: Props) => (
  <OBadge
    className={[`badge-${size}`, className].join(' ')}
    variant="secondary">
    BETA
  </OBadge>
)
export default React.memo(BetaBadge)
